import { DATE_FORMAT, type DeliveryTimeSlot, DeliveryTimeSlotMap } from '@constants'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface OrderNoteProps {
  deliveryTimeSlot?: DeliveryTimeSlot
  deliveryDate?: string
  customerNote?: string
  rootStyle?: stylex.StyleXStyles
}

export function OrderNote({ deliveryTimeSlot, deliveryDate, customerNote, rootStyle }: OrderNoteProps) {
  const { t } = useTranslation()
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">{t('orderDetail.shippingNote', { defaultValue: '收貨備註' })}</Text>
      <Box rootStyle={styles.info}>
        <Text noWrap color={colors.grey600}>{t('orderDetail.deliveryTime', { defaultValue: '收貨時間' })}</Text>
        <Text>{deliveryTimeSlot ? DeliveryTimeSlotMap[deliveryTimeSlot] : '-'}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text noWrap color={colors.grey600}>{t('orderDetail.estimatedArrival', { defaultValue: '預計到貨日' })}</Text>
        <Text>{deliveryDate ? format(new Date(deliveryDate), DATE_FORMAT) : '-'}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text noWrap color={colors.grey600}>{t('orderDetail.remark', { defaultValue: '備註' })}</Text>
        <Text>{customerNote || '-'}</Text>
      </Box>
    </VStack>
  )
}
